import React from 'react';
import { FaInstagram, FaFacebook, FaThreads } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { useLocale } from '../context/LocaleContext';

export default function SocialFooter({ onOpenSponsor }) {
  const { t } = useLocale();
  const currentYear = 2026;

  return (
    <footer className="w-full py-10 mt-8 flex flex-col items-center justify-center gap-6 relative z-10">
      {onOpenSponsor && (
        <button onClick={onOpenSponsor} className="group relative overflow-hidden bg-white dark:bg-slate-800 px-6 py-3 rounded-2xl shadow-sm border border-pink-100 dark:border-slate-700 hover:border-pink-300 dark:hover:border-pink-500 hover:shadow-md transition-all duration-300 mb-2">
          <div className="absolute inset-0 bg-gradient-to-r from-pink-50 to-rose-50 dark:from-pink-900/10 dark:to-rose-900/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <span className="relative flex items-center gap-2 font-bold text-gray-600 dark:text-gray-300 group-hover:text-pink-600 dark:group-hover:text-pink-400 transition-colors">
            <SafeIcon name="Coffee" className="w-5 h-5 text-pink-400 group-hover:animate-bounce" />
            {t('sponsor.coffee')}
          </span>
        </button>
      )}

      {/* 底部導覽列 (SEO 與手機版快速連結) */}
      <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 mb-2">
        <Link to="/" className="text-sm font-bold text-gray-500 dark:text-gray-400 hover:text-pink-500 dark:hover:text-pink-400 transition-colors flex items-center gap-1.5">
          <SafeIcon name="Home" className="w-4 h-4" />
          {t('nav.home')}
        </Link>
        <Link to="/features" className="text-sm font-bold text-gray-500 dark:text-gray-400 hover:text-pink-500 dark:hover:text-pink-400 transition-colors flex items-center gap-1.5">
          <SafeIcon name="Star" className="w-4 h-4" />
          {t('nav.features')}
        </Link>
        <Link to="/help" className="text-sm font-bold text-gray-500 dark:text-gray-400 hover:text-pink-500 dark:hover:text-pink-400 transition-colors flex items-center gap-1.5">
          <SafeIcon name="HelpCircle" className="w-4 h-4" />
          {t('nav.help')}
        </Link>
        <Link to="/about" className="text-sm font-bold text-gray-500 dark:text-gray-400 hover:text-pink-500 dark:hover:text-pink-400 transition-colors flex items-center gap-1.5">
          <SafeIcon name="Info" className="w-4 h-4" />
          {t('nav.about') || 'About'}
        </Link>
      </div>

      <div className="flex flex-col items-center gap-5">
        <div className="flex items-center gap-4 mb-1">
          <div className="h-px w-12 bg-gray-200 dark:bg-slate-700"></div>
          <p className="text-sm font-bold text-gray-400 dark:text-gray-500 tracking-wider">{t('footer.follow')}</p>
          <div className="h-px w-12 bg-gray-200 dark:bg-slate-700"></div>
        </div>
        <div className="flex items-center gap-5">
          <a href="https://www.instagram.com/homy.hk" target="_blank" rel="noopener noreferrer" title="Instagram" className="w-12 h-12 rounded-2xl bg-white dark:bg-slate-800 flex items-center justify-center text-gray-400 hover:text-white hover:bg-gradient-to-tr hover:from-yellow-400 hover:via-pink-500 hover:to-purple-500 transition-all duration-300 shadow-sm border border-gray-100 dark:border-slate-700 hover:border-transparent hover:shadow-lg hover:-translate-y-1">
            <SafeIcon icon={FaInstagram} className="w-6 h-6" />
          </a>
          <a href="https://www.threads.com/@homy.hk" target="_blank" rel="noopener noreferrer" title="Threads" className="w-12 h-12 rounded-2xl bg-white dark:bg-slate-800 flex items-center justify-center text-gray-400 hover:text-white hover:bg-black dark:hover:bg-white dark:hover:text-black transition-all duration-300 shadow-sm border border-gray-100 dark:border-slate-700 hover:border-transparent hover:shadow-lg hover:-translate-y-1">
            <SafeIcon icon={FaThreads} className="w-6 h-6" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61578745554661" target="_blank" rel="noopener noreferrer" title="Facebook" className="w-12 h-12 rounded-2xl bg-white dark:bg-slate-800 flex items-center justify-center text-gray-400 hover:text-white hover:bg-blue-600 transition-all duration-300 shadow-sm border border-gray-100 dark:border-slate-700 hover:border-transparent hover:shadow-lg hover:-translate-y-1">
            <SafeIcon icon={FaFacebook} className="w-6 h-6" />
          </a>
        </div>
      </div>

      <div className="mt-2 text-center flex flex-col items-center gap-1.5">
        <p className="text-xs font-medium text-gray-400 dark:text-gray-500 flex items-center justify-center flex-wrap gap-1">
          &copy; {currentYear} {t('nav.brandSubtitle')} <span className="mx-1">·</span> {t('footer.madeWith')} <SafeIcon name="Heart" className="w-3 h-3 text-pink-400 animate-pulse" /> {t('footer.by')}
          <a href="https://homy.hk" target="_blank" rel="noopener noreferrer" className="font-bold text-gray-500 dark:text-gray-400 hover:text-pink-500 dark:hover:text-pink-400 transition-colors inline-block ml-1">
            Homy Tech Limited
          </a>
        </p>
      </div>
    </footer>
  );
}